import { IEvent } from './types';

export function getUniqueCategories(events: IEvent[]) {
  const set = new Set<string>();
  events.forEach((e) => e.categories.forEach((c) => set.add(c)));
  return Array.from(set);
}

export function filterEvents(events, filter?: string) {
  return filter ? events.filter((e) => e.categories.includes(filter)) : events;
}
